import Vue from 'vue';
import vueBemCn from 'vue-bem-cn';
import VModal from 'vue-js-modal';
import { Col, Row } from 'simple-xgrid/src/components';
import 'simple-xgrid/dist/simple-grid.css';
import store from '@/store';

Vue.config.productionTip = false;
/**
 * @deprecated
 */
Vue.use(vueBemCn, {
  hyphenate: true,
  methodName: 'b',
  delimiters: {
    ns: '',
    el: '__',
    mod: '_',
    modVal: '_',
  },
});
Vue.use(VModal, {
  componentName: 'VModal',
});
/**
 * @deprecated
 */
Vue.component('GridCol', Col);
/**
 * @deprecated
 */
Vue.component('GridRow', Row);

/**
 * Фабрика vue-страницы
 *
 * @param {string} element
 * @param {Object} component
 * @returns {CombinedVueInstance<Object>}
 * @constructor
 */
export default function factoryPage(element, component) {
  return new Vue({
    el: element,
    store,
    render: (h) => h(component),
  });
}
